import { render } from "./RecordContentView.vue?vue&type=template&id=b2fd8e30&scoped=true"
import script from "./RecordContentView.vue?vue&type=script&lang=js"
export * from "./RecordContentView.vue?vue&type=script&lang=js"

import "./RecordContentView.vue?vue&type=style&index=0&id=b2fd8e30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fd8e30"]])

export default __exports__